module.exports = __webpack_public_path__ + "img/Trillionaire-3.f8ced1bc.png";